import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <a href="/home" className="text-primary underline hover:text-primary/90">
          Return to Home
          "view-lead",
        "add-lead",
        "lead-edit",
        "customers-index",
        "customers-add",
        "view-expenses",
        "add-expenses",
        "expenses-edit",
        "expenses-delete",
        "loan-application",
        "loan-approval",
        "loan-disbursement",
         "move-customers",
        "loan-writeoff",
        "customer-approval",
        "messenger",
        "draft",
        "addressbook",
        "outbox",
        "create-asset",
        "upload-files",
        "review-status",
        "account-actions",
        "dashboard",
        "mpesa-bal",
        "summary-report",
        "my-target",
        "disbursement-target",
        "dis-target-history",
        "bdo-target",
        "branch-target",
        "mpesa-records",
        "unresolved-mpesa-records",
        "change-branch",
        "dis-calendar",
        "co-calendar",
        "reports",
        "management-reports",
        "manage-finance",
        "books-accounts",
        "settings",
        "lead-delete",
        "edit-phonenumber",
        "pair",
        "loan-debit-credit",
        "loan-credit-limit",
        "promise-topay",
        "customer-notes",
        "edit-customer",
        "manual-payment",
        "alt-phonenumber",
        "edit-loan",
        "all-branch",
        "co_loan-approval"

        <Route path="/actions/collection" element={
                  <PlaceholderPage title="Collection" />
                  } />
                <Route path="/actions/disbursed" element={<PlaceholderPage title="Disbursed" />} />
                <Route path="/actions/expenses" element={<PlaceholderPage title="Expenses" />} />
                                <Route path="/actions/messenger" element={<PlaceholderPage title="Messenger" />} />
                                <Route path="/financial/revenue" element={<PlaceholderPage title="Revenue Reports" />} />
                                <Route path="/financial/collections" element={<PlaceholderPage title="Collections Reports" />} />
        </a>
      </div>
    </div>
  );
};

export default NotFound;
